import { createStyles } from '@/contexts/theme-context';
import { Icons, Typography, XStack, YStack } from '@usepepper/sprout-kit-ui';

// Lines the icon up with the first line of text in our banner as per design
const LOCK_ICON_MARGIN_TOP = 3;

interface OrderGuideViewOnlyBannerProps {
  description: string;
  title: string;
}
export const OrderGuideViewOnlyBanner: React.FC<
  OrderGuideViewOnlyBannerProps
> = ({ description, title }) => {
  const [styles, theme] = useStyles();

  return (
    <XStack
      accessibilityRole="alert"
      alignItems="flex-start"
      gap={theme.sk.spacing.spaceSMedium}
      paddingHorizontal="$size.14"
      paddingVertical={theme.sk.spacing.spaceSMedium}
      style={styles.banner}
    >
      <Icons.Lock
        accessibilityElementsHidden
        color="$iconWarningPrimary"
        importantForAccessibility="no-hide-descendants"
        marginTop={LOCK_ICON_MARGIN_TOP}
        size="$14"
      />
      <YStack gap="$2" style={styles.bannerText}>
        <Typography fontWeight="$semibold" size="$sm">
          {title}
        </Typography>
        <Typography color={theme.sk.color.text.secondary} size="$sm">
          {description}
        </Typography>
      </YStack>
    </XStack>
  );
};

const useStyles = createStyles((theme) => ({
  banner: {
    backgroundColor: theme.sk.color.bg.highlight.warning,
    borderRadius: theme.sk.radii.radiusMedium,
    marginBottom: theme.sk.spacing.spaceSmall,
  },
  bannerText: {
    flexShrink: 1,
  },
}));
